import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ProgressBar } from './ProgressBar';
import { StepIndicators } from './StepIndicators';
import { useForm } from '../context/FormContext';
export var FormProgress = function (_a) {
    var _b, _c;
    var disablePreviousSteps = _a.disablePreviousSteps;
    var state = useForm().state;
    // Get steps from window.tiofSettings
    var steps = ((_c = (_b = window.tiofSettings) === null || _b === void 0 ? void 0 : _b.formConfig) === null || _c === void 0 ? void 0 : _c.steps) || [
        { id: 'vehicle-info', label: 'Find Your Car' },
        { id: 'contact-details', label: 'Your Details' },
        { id: 'condition-report', label: 'Vehicle Condition' },
        { id: 'estimate-appointment', label: 'Your Free Online Estimate' }
    ];
    return (_jsx("div", { className: "tiof-progress-outer-wrapper", children: _jsxs("div", { className: "tiof-progress-wrapper container", children: [_jsx(ProgressBar, { currentStep: state.currentStep, totalSteps: steps.length }), _jsx(StepIndicators, { steps: steps, currentStep: state.currentStep, disablePreviousSteps: disablePreviousSteps })] }) }));
};
